import { Checkbox, DatePicker, Form, Select } from "antd";
import { ReactElement, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import "./edit-professional-details.scss";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";

import { useDispatch } from "react-redux";
import { AxiosResponse } from "axios";
import toast from "react-hot-toast";
import { useForm } from "antd/lib/form/Form";
import { LOADING } from "src/store/actions";
import instance from "src/store/axios";
import Label from "src/components/label/label.component";
import CustomInput from "src/components/custom-input/custom-input.component";
import { getStandingDataOptions } from "src/utils/helper/functions";

const EditProfesionalDetails: React.FC<{
  standingData: any;
  accountDetails: any;
  onSuccess: () => void;
}> = ({ standingData, accountDetails, onSuccess }): ReactElement => {
  const { accountId, activeKyc } = useParams();
  const [form] = useForm();
  Form.useWatch([], form);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isApproveCase = queryParams.get("approve");

  const isPoliticalPerson = (): boolean => {
    if (
      accountDetails?.accountInfo[0]?.pep1 ||
      accountDetails?.accountInfo[0]?.pep2 ||
      accountDetails?.accountInfo[0]?.pep3 ||
      accountDetails?.accountInfo[0]?.pep4 ||
      accountDetails?.accountInfo[0]?.pep5 ||
      accountDetails?.accountInfo[0]?.pep7
    ) {
      return true;
    }

    return false;
  };

  const getIsDealingValues = (): string[] => {
    const array: string[] = [];
    if (accountDetails?.accountInfo[0]?.isDealingInSecurities) {
      array.push("isDealingInSecurities");
    }
    if (accountDetails?.accountInfo[0]?.isFundsInKamco) {
      array.push("isFundsInKamco");
    }
    if (accountDetails?.accountInfo[0]?.isWorkInFinancial) {
      array.push("isWorkInFinancial");
    }
    return array;
  };

  const getPepsValue = (): string[] => {
    const array: string[] = [];
    for (let i = 1; i <= 7; i++) {
      if (
        accountDetails?.accountInfo[0] &&
        accountDetails?.accountInfo[0][`pep${i}`]
      ) {
        array.push(`pep${i}`);
      }
    }
    return array;
  };

  const onSubmit = async (values: any) => {
    dispatch({ type: LOADING, payload: true });

    values.kycId = accountDetails.accountInfo[0]?.id;
    values.branch = "SA";

    for (let i = 1; i <= 7; i++) {
      if (values.politicalPerson) {
        values.pep8 = false;
        values?.peps?.includes(`pep${i}`)
          ? (values[`pep${i}`] = true)
          : (values[`pep${i}`] = false);
      } else {
        values.pep8 = true;
        values[`pep${i}`] = false;
      }
    }
    delete values.peps;
    values.isDealingInSecurities = false;
    values.isFundsInKamco = false;
    values.isWorkInFinancial = false;

    if (values.isDealing?.includes("isDealingInSecurities")) {
      values.isDealingInSecurities = true;
    }
    if (values.isDealing?.includes("isFundsInKamco")) {
      values.isFundsInKamco = true;
    }
    if (values.isDealing?.includes("isWorkInFinancial")) {
      values.isWorkInFinancial = true;
    }

    delete values.isDealing;

    try {
      await instance.post(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/account/${accountId}/professional/update`,
        values
      );

      await instance.post(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/account/${accountId}/prefrence-info/update`,
        values
      );

      onSuccess();

      dispatch({ type: LOADING, payload: false });
      toast.success("Professional information updated successfully");
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
        localStorage.setItem(
          "star_prev_url",
          `/home/new-kyc/${accountDetails?.id}/${accountDetails?.pendingKycId}`
        );
      }
    }

    dispatch({ type: LOADING, payload: false });
  };

  return (
    <div className="edit-professional-details flex flex-col mt-5">
      <h2 className=" font-semibold text-xl">Professional information</h2>
      {accountDetails?.id && (
        <Form
          className="add-edit-form flex flex-col gap-5"
          initialValues={{
            employmentStatusId:
              accountDetails?.accountInfo[0]?.employmentStatusId,
            employerName: accountDetails?.accountInfo[0]?.employerName,
            occupationTitle: accountDetails?.accountInfo[0]?.occupationTitle,
            retirementAddress:
              accountDetails?.accountInfo[0]?.retirementAddress,
            workNature: accountDetails?.accountInfo[0]?.workNature,
            educationLevelId: accountDetails?.accountInfo[0]?.educationLevelId,
            isDealing: getIsDealingValues(),
            politicalPerson: isPoliticalPerson(),
            isBoardMember: accountDetails?.accountInfo[0]?.isBoardMember,
            boardMemberDetails:
              accountDetails?.accountInfo[0]?.boardMemberDetails,
            categories: !accountDetails?.accountInfo[0]?.pep8,
            peps: getPepsValue(),
            pepDetails: accountDetails?.accountInfo[0]?.pepDetails,
            hasAccreditedCertifications:
              accountDetails?.accountInfo[0]?.hasAccreditedCertifications,
            certifications: accountDetails?.accountInfo[0]?.certifications
              ?.split("|")
              ?.map((item: string) => +item.trim()),
            reportingCurrency:
              accountDetails?.accountInfo[0]?.reportingCurrency,
            preferredLanguageId:
              accountDetails?.accountInfo[0]?.preferredLanguageId,
            preferredInvestmentAssetsId:
              accountDetails?.accountInfo[0]?.preferredInvestmentAssetsId,
            correspondencePreferenceId:
              accountDetails?.accountInfo[0]?.correspondencePreferenceId || standingData?.media[0]?.id,
            primaryEmail: accountDetails?.accountInfo[0]?.primaryEmail,
            fax: accountDetails?.accountInfo[0]?.fax,
            yearOfRetirement: accountDetails?.accountInfo[0]?.yearOfRetirement ? dayjs(
              accountDetails?.accountInfo[0]?.yearOfRetirement
            ) : null,
            employmentDurationId: accountDetails?.accountInfo[0]?.employmentDuration?.id,
            hasAssociationWithBoardMembers: accountDetails?.accountInfo[0]?.hasAssociationWithBoardMembers,
            isAssignedtoProminentFunction: accountDetails?.accountInfo[0]?.isAssignedtoProminentFunction,
            isRelatedToProminentMember: accountDetails?.accountInfo[0]?.isRelatedToProminentMember,
          }}
          form={form}
          onFinish={onSubmit}
        >
          <div className="flex gap-3 items-center">
            <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
            <h3 className=" text-lg font-semibold">Work details</h3>
          </div>
          <div className="fields flex justify-space-between wrap">
            <div className="field flex flex-col">
              <Label text="Type of employment" required />
              <Form.Item
                name="employmentStatusId"
                rules={[
                  {
                    required: true,
                    message: "Please select the type of employment!",
                  },
                ]}
              >
                <Select
                  placeholder="Select type of employment"
                  options={getStandingDataOptions(
                    standingData,
                    "employment",
                    ["sa", "gc"],
                    false
                  )}
                />
              </Form.Item>
            </div>

            {(form.getFieldValue("employmentStatusId") == "268" ||
              form.getFieldValue("employmentStatusId") == "269" || form.getFieldValue("employmentStatusId") == 271) && (
                <>
                  <div className="field flex flex-col">
                    <Label text="Employer Name" required={form.getFieldValue("employmentStatusId") == "268" ||
                      form.getFieldValue("employmentStatusId") == "269" ||
                      form.getFieldValue("employmentStatusId") == 271} />
                    <Form.Item
                      name="workNature"
                      rules={[
                        {
                          required:
                            form.getFieldValue("employmentStatusId") == "268" ||
                              form.getFieldValue("employmentStatusId") == "269" ||
                              form.getFieldValue("employmentStatusId") == 271
                              ? true
                              : false,
                          message: "Please input employer name!",
                        },
                      ]}
                    >
                      <CustomInput placeholder="Enter employer name" />
                    </Form.Item>
                  </div>
                </>
              )}

            {(form.getFieldValue("employmentStatusId") == "268" ||
              form.getFieldValue("employmentStatusId") == "269" || form.getFieldValue("employmentStatusId") == 271) && (
                <>
                  <div className="field flex flex-col">
                    <Label text="Position / Title" required={form.getFieldValue("employmentStatusId") == "268" ||
                      form.getFieldValue("employmentStatusId") == "269" ||
                      form.getFieldValue("employmentStatusId") == 271} />
                    <Form.Item
                      name="occupationTitle"
                      rules={[
                        {
                          required:
                            form.getFieldValue("employmentStatusId") == "268" ||
                              form.getFieldValue("employmentStatusId") == "269" ||
                              form.getFieldValue("employmentStatusId") == 271
                              ? true
                              : false,
                          message: "Please input position / title!",
                        },
                      ]}
                    >
                      <CustomInput placeholder="Enter position / title" />
                    </Form.Item>
                  </div>
                </>
              )}

            {(form.getFieldValue("employmentStatusId") == "268" ||
              form.getFieldValue("employmentStatusId") == "269" || form.getFieldValue("employmentStatusId") == 271) && (
                <div className="field flex flex-col">
                  <Label text="Duration of Employment (in years)" required={form.getFieldValue("employmentStatusId") == "268" ||
                    form.getFieldValue("employmentStatusId") == "269" ||
                    form.getFieldValue("employmentStatusId") == 271} />
                  <Form.Item
                    name="employmentDurationId"
                    rules={[
                      {
                        required:
                          form.getFieldValue("employmentStatusId") == "268" ||
                            form.getFieldValue("employmentStatusId") == "269" ||
                            form.getFieldValue("employmentStatusId") == 271
                            ? true
                            : false,
                        message: "Please select the duration of employment!",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select duration of employment"
                      options={getStandingDataOptions(
                        standingData,
                        "employmentDuration",
                        ["sa", "gc"]
                      )}
                    />
                  </Form.Item>
                </div>
              )}

            {form.getFieldValue("employmentStatusId") == 35 && (
              <>
                <div className="field flex flex-col">
                  <Label text="Employer Name" />
                  <Form.Item
                    name="employerName"
                    rules={[
                      {
                        required:
                          form.getFieldValue("employmentStatusId") == 35
                            ? true
                            : false,
                        message: "Please input employer name!",
                      },
                      {
                        max: 60,
                        message: "Maximum 60 characters allowed",
                      },
                    ]}
                  >
                    <CustomInput placeholder="Enter employer name" />
                  </Form.Item>
                </div>
                <div className="field flex column">
                  <Label text="Occupation & Title" />
                  <Form.Item
                    name="occupationTitle"
                    rules={[
                      {
                        required:
                          form.getFieldValue("employmentStatusId") == 35
                            ? true
                            : false,
                        message: "Please input occupation & title!",
                      },
                      {
                        max: 50,
                        message: "Maximum 50 characters allowed",
                      },
                    ]}
                  >
                    <CustomInput placeholder="Enter occupation & title" />
                  </Form.Item>
                </div>
              </>
            )}

            {form.getFieldValue("employmentStatusId") == 33 && (
              <>
                <div className="field flex flex-col">
                  <Label text="Retirement year" required={form.getFieldValue("employmentStatusId") == 33} />
                  <Form.Item
                    name="yearOfRetirement"
                    rules={[
                      {
                        required:
                          form.getFieldValue("employmentStatusId") == 33
                            ? true
                            : false,
                        message: "Please select retirement year!",
                      },
                    ]}
                  >
                    <DatePicker
                      placeholder="Select retirement year"
                      format="YYYY"
                      picker="year"
                      className="w-full rounded-lg"
                      disabledDate={(current) => current && current.isAfter(new Date())}
                      style={{ width: "100%" }}
                      allowClear={false}
                    />
                  </Form.Item>
                </div>
                <div className="field flex flex-col">
                  <Label text="Previous Employer Name" />
                  <Form.Item name="employerName">
                    <CustomInput placeholder="Enter previous employer name" />
                  </Form.Item>
                </div>
                <div className="field flex flex-col">
                  <Label text="Previous Position / Title" />
                  <Form.Item name="occupationTitle">
                    <CustomInput placeholder="Enter previous position / title" />
                  </Form.Item>
                </div>
                <div className="field flex flex-col">
                  <Label text="Previous Work Address" />
                  <Form.Item name="retirementAddress">
                    <CustomInput placeholder="Enter previous work address" />
                  </Form.Item>
                </div>
              </>
            )}

            {form.getFieldValue("employmentStatusId") == 34 && (
              <div className="field flex column">
                <Label text="Nature of Work" />
                <Form.Item name="workNature">
                  <CustomInput placeholder="Enter nature of work" />
                </Form.Item>
              </div>
            )}

            {/* <div className="field flex column">
              <Label text="Are you a Politically Exposed Person?" />
              <Form.Item
                name="politicalPerson"
                rules={[
                  {
                    required: true,
                    message:
                      "Please select Are you a Politically Exposed Person?",
                  },
                ]}
              >
                <Select
                  placeholder="Are you a Politically Exposed Person?"
                  options={[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ]}
                />
              </Form.Item>
            </div> */}

            {form.getFieldValue("politicalPerson") && (
              <div className="fields flex flex-col">
                <Label text="If you belong to any of the following categories, please select and give details below:" />
                <Form.Item
                  name="peps"
                  rules={[
                    {
                      required: form.getFieldValue("politicalPerson")
                        ? true
                        : false,
                      message: "Please select at leaser one category!",
                    },
                  ]}
                >
                  <Checkbox.Group
                    className="flex flex-col"
                    options={getStandingDataOptions(standingData, "pepTypes", [
                      "sa",
                      "gc",
                    ])}
                  ></Checkbox.Group>
                </Form.Item>
              </div>
            )}

            {form.getFieldValue("politicalPerson") && (
              <div className="fields flex flex-col">
                <Label text="Details" />
                <Form.Item name="pepDetails">
                  <TextArea rows={4} placeholder="Enter details" />
                </Form.Item>
              </div>
            )}

            <div className="fields flex justify-space-between wrap">
              <div className="field flex flex-col">
                <Label text="Are you a board of directors member, an audit committee member or a
senior executive in a listed company?" required />
                <Form.Item
                  name="isBoardMember"
                  rules={[
                    {
                      required: true,
                      message: "Please choose if you are a member of the board of directors or member of the executive management or an insider of a listed company!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select"
                    options={[
                      { value: true, label: "Yes" },
                      { value: false, label: "No" },
                    ]}
                  />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Have a close association with a board of directors member,
an audit committee member or a senior executive in a listed
company?" required />
                <Form.Item
                  name="hasAssociationWithBoardMembers"
                  rules={[
                    {
                      required: true,
                      message: "Please choose if you have a close association with a board of directors member, an audit committee member or a senior executive in a listed company!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select"
                    options={[
                      { value: true, label: "Yes" },
                      { value: false, label: "No" },
                    ]}
                  />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Assigned with prominent public functions in the Kingdom or a
foreign country, senior management positions, or a position in
an international organization?" required />
                <Form.Item
                  name="isAssignedtoProminentFunction"
                  rules={[
                    {
                      required: true,
                      message: "Please choose if you are assigned with prominent public functions in the Kingdom or a foreign country, senior management positions, or a position in an international organization!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select"
                    options={[
                      { value: true, label: "Yes" },
                      { value: false, label: "No" },
                    ]}
                  />
                </Form.Item>
              </div>

              <div className="field flex flex-col">
                <Label text="Does the client have a relationship (by blood or marriage up to the second degree), or have an association with a person entrusted with a prominent public function in the Kingdom or a foreign country, senior management positions, or a position in an international organization." required />
                <Form.Item
                  name="isRelatedToProminentMember"
                  rules={[
                    {
                      required: true,
                      message: "Please choose if you have a relationship (by blood or marriage up to the second degree), or have an association with a person entrusted with a prominent public function in the Kingdom or a foreign country, senior management positions, or a position in an international organization!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select"
                    options={[
                      { value: true, label: "Yes" },
                      { value: false, label: "No" },
                    ]}
                  />
                </Form.Item>
              </div>
            </div>
          </div>

          <div className="flex gap-3 items-center">
            <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
            <h3 className=" text-lg font-semibold">Preferences details</h3>
          </div>
          <div className="fields flex justify-space-between wrap">
            <div className="field flex column">
              <Label text="Account language" required />
              <Form.Item
                name="preferredLanguageId"
                rules={[
                  {
                    required: true,
                    message: "Please select Account language!",
                  },
                ]}
              >
                <Select
                  placeholder="Select account language"
                  options={getStandingDataOptions(standingData, "language", [
                    "sa",
                    "gc",
                  ])}
                />
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="Preferred reporting currency" />
              <Form.Item
                name="reportingCurrency"

              >
                <Select
                  placeholder="Select currency"
                  options={standingData?.PREFERRED_CURRENCY?.map(
                    (item: any) => ({
                      value: item.description,
                      label: item.description,
                    })
                  )}
                />
              </Form.Item>
            </div>

            <div className="field flex flex-col">
              <Label text="Correspondence preference" required />
              <Form.Item
                name="correspondencePreferenceId"
              >
                <Select
                  placeholder="Select correspondence preference"
                  // onChange={onCorrespondenceChange}

                  options={getStandingDataOptions(standingData, "media", [
                    "sa",
                    "gc",
                  ])}
                />
              </Form.Item>
              {/* <span>
                Trade confirmations will be sent end of every week if
                residential address, work address, or P.O.Box are selected. By
                selecting e-mail or fax you will receive the confirmations
                instantly
              </span> */}
            </div>

            {form.getFieldValue("correspondencePreferenceId") === 67 && (
              <div className="field flex column">
                <Label text="E-mail" required />
                <Form.Item
                  name="primaryEmail"
                  rules={[
                    {
                      required: true,
                      message: "Please select E-mail!",
                    },
                    {
                      type: "email",
                      message: "Please enter valid email!",
                    },
                  ]}
                >
                  <CustomInput
                    placeholder="Enter E-mail"
                    value={accountDetails?.accountInfo[0]?.primaryEmail}
                  />
                </Form.Item>
              </div>
            )}
          </div>

          <div className="flex gap-3 items-center">
            <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
            <h3 className=" text-lg font-semibold">Education information</h3>
          </div>
          <div className="fields flex justify-space-between wrap">
            <div className="fields flex column wrap">
              <div className="fields flex wrap justify-space-between">
                <div className="field flex column">
                  <Label text="Education Level" required />
                  <Form.Item
                    name="educationLevelId"
                    rules={[
                      {
                        required: true,
                        message: "Please input education level!",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select education level"
                      options={[
                        ...getStandingDataOptions(
                          standingData,
                          "education",
                          ["sa", "gc"],
                          false
                        ),
                      ]}
                    />
                  </Form.Item>
                </div>

                <div className="field flex flex-col">
                  <Label text="Does the client hold any accredited professional
                    certifications?" required />


                  <Form.Item
                    name="hasAccreditedCertifications"
                    rules={[
                      {
                        required: true,
                        message: "Please choose an answer!",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select answer"
                      options={[
                        { value: true, label: "Yes" },
                        { value: false, label: "No" },
                      ]}
                    />
                  </Form.Item>
                </div>

                {form.getFieldValue("hasAccreditedCertifications") && (
                  <div className="field flex flex-col">
                    <Label text="Which of the following certifications does the client
                      hold?" required />
                    <Form.Item
                      name="certifications"
                      rules={[
                        {
                          required: true,
                          message: "Please select the certifications!",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select answer"
                        mode="multiple"
                        maxTagCount="responsive"
                        options={[
                          ...getStandingDataOptions(
                            standingData,
                            "certifications",
                            ["sa", "gc"]
                          ),
                        ]}
                      />
                    </Form.Item>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="flex w-full flex-wrap items-center justify-end mt-7 pt-5">
            <div className="flex justify-between items-center w-[70%] md:w-[48%]">
              <button
                onClick={() =>
                  navigate(
                    `/home/customers-list`
                  )
                }
                className="rounded-lg bg-white w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-blue-500"
              >
                Cancel
              </button>
              <button className="disabled:opacity-50 disabled:cursor-not-allowed rounded-lg bg-blue-500 w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-white">
                Save and continue
              </button>
            </div>
          </div>
        </Form>
      )}
    </div>
  );
};

export default EditProfesionalDetails;
